var exports = {
  "qr": "EditingMessageInput.module__footer___V1IxLS",
  "s6": "EditingMessageInput.module__footerLink___V1IxLS",
  "me": "EditingMessageInput.module__separator___V1IxLS",
  "EN": "EditingMessageInput.module__editor___V1IxLS",
};

module.exports = exports;
